import React from "react";

import { useTranslation } from "react-i18next";

import { FormTextInput } from "@/uiKit/molecules/form/FormTextInput.tsx";

export type PatientLastNameFormFieldProps = {
  name?: string;
  labelType?: "left" | "default";
  className?: string;
};

export const PatientLastNameFormField: React.FC<PatientLastNameFormFieldProps> = ({
  name = "familyName",
  labelType = "default",
  className,
}) => {
  const { t } = useTranslation();
  return (
    <FormTextInput
      id="patient-lastname-form-field"
      name={name}
      label={t("profile.lastname")}
      autoComplete="family-name"
      className={className}
      labelType={labelType}
      reserveErrorSpace
    />
  );
};
